<t4-container [title]="title" [isLoading]="isLoading">
    <div class="kpi" #Panel [ngStyle]="{ 'font-size': autoFontSize }">
        <div class="content">
            <div class="value" *ngIf="type != 'chart'">
                <div *ngIf="type == 'numeric'">{{ Value | number : '1.0-2' }}</div>
                <div *ngIf="type == 'currency'">{{ Value | currency }}</div>
                <div *ngIf="type == 'percent'">{{ Value | percent : '1.0-1' }}</div>
            </div>
            <div class="relatedValue" *ngIf="type != 'chart'">
                <div *ngIf="type == 'numeric'">{{ RelatedValue | number : '1.0-2' }}</div>
                <div *ngIf="type == 'currency'">{{ RelatedValue | currency }}</div>
                <div *ngIf="type == 'percent'">{{ RelatedValue | percent : '1.0-1' }}</div>
            </div>
            <div class="delta" [ngClass]="{'positive': InterpretationIsPositive, 'negative': InterpretationIsNegative}" *ngIf="type != 'chart'"><div><mat-icon *ngIf="(!invert && InterpretationIsNegative) ||(invert && InterpretationIsPositive)">arrow_drop_down</mat-icon><mat-icon *ngIf="(!invert && InterpretationIsPositive) ||(invert && InterpretationIsNegative)">arrow_drop_up</mat-icon>{{ Delta | percent : '1.0-2' }}</div></div>
            <div *ngIf="type != 'chart'" class="legend">{{ 'T4.Common.Kpi.lblInPeriod' | translate : 'In period' }}</div>
            <div *ngIf="type != 'chart'" class="legend" style="bottom: 0;">{{ 'T4.Common.Kpi.lblInPreviousYear' | translate : 'Previous year' }}</div>
            <canvas *ngIf="type == 'chart'" mdbChart
                    type="pie"
                    [datasets]="percentageData"
                    [options]="percentageOptions"
                    [colors]="percentageColors"
                    [labels]="chartLabels"
                    [legend]="true"></canvas>
        </div>
    </div>
</t4-container>
